const LEVEL_COLOR = { eleve: "bg-rose-500", modere: "bg-amber-500", faible: "bg-emerald-500" };

export const StScoreBars = ({ scoring, dims, domains }) => {
  const rows = dims.filter((d) => scoring.dims[d.key]);
  return (
    <div className="space-y-3 pt-2" data-testid="stq-score-bars">
      {domains && scoring.domains && (
        <div className="flex flex-wrap gap-1.5" data-testid="stq-domains">
          {domains.filter((d) => scoring.domains[d.key] !== undefined).map((d) => <span key={d.key} className="text-[11px] px-2 py-0.5 rounded bg-muted">{d.label} : <b>{scoring.domains[d.key].toFixed(1)}</b></span>)}
        </div>
      )}
      <div className="space-y-1.5">
        {rows.map((d) => {
          const v = scoring.dims[d.key];
          return (
            <div key={d.key} className="grid grid-cols-[minmax(0,1fr)_auto] sm:grid-cols-[220px_1fr_auto] items-center gap-2 text-xs" data-testid={`stq-bar-${d.key}`}>
              <span className="truncate" title={d.label}>{d.label}</span>
              <div className="hidden sm:block h-2.5 rounded-full bg-muted overflow-hidden"><div className={`h-full rounded-full ${LEVEL_COLOR[v.level]}`} style={{ width: `${((v.mean - 1) / 5) * 100}%` }} /></div>
              <span className="tabular-nums w-20 text-right">{v.mean.toFixed(1)} / 6{v.high_items !== null && v.high_items !== undefined ? ` · ${v.high_items}★` : ""}</span>
            </div>
          );
        })}
      </div>
      <p className="text-[11px] text-muted-foreground">★ = nombre d'items cotés 5 ou 6. Repères indicatifs : élevé ≥ {dims[0]?.domain ? "4,5" : "4,0"} · modéré ≥ {dims[0]?.domain ? "3,5" : "3,0"}.</p>
    </div>
  );
};
